import BaseInstance from "../base.instance";
import {
  PRESENSI_FEATURE
} from "../constants";

const FeatureService = {
  getList(params) {
    return BaseInstance.query(PRESENSI_FEATURE, { params });
  },
};

export default FeatureService;
